export default (array: number[], timezoneOffset: number): number[] => {
  const from = timezoneOffset > 0 ? 7 * 24 * 60 : 0;
  const start = array.slice(from - timezoneOffset, 7 * 24 * 60);
  const end = array.slice(0, from - timezoneOffset);
  return start.concat(end);
};
